import React, { useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  Button,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import NavArea from "../Home/Header/NavArea";
import ParticlesBg from "particles-bg";
import project from "../../images/undraw_Organizing_projects_0p9a.svg";
import "./AllProjects.css";
import Headroom from "react-headroom";
import Footer from "../Footer/Footer";

import AOS from "aos";
import "aos/dist/aos.css";

const AllProjects = () => {
  useEffect(() => {
    AOS.init({
      duration: 2200,
    });

    AOS.refreshHard();
  }, []);

  let config = {
    num: [4, 7],
    rps: 0.1,
    radius: [5, 40],
    life: [1.5, 3],
    v: [2, 3],
    tha: [-40, 40],
    alpha: [0.6, 0],
    scale: [0.1, 0.4],
    position: "fixed",
    color: ["random", "#ff0000"],
    cross: "dead",
    random: 15,
  };
  if (Math.random() > 0.85) {
    config = Object.assign(config, {
      onParticleUpdate: (ctx, particle) => {
        ctx.beginPath();
        ctx.rect(
          particle.p.x,
          particle.p.y,
          particle.radius * 2,
          particle.radius * 2
        );
        ctx.fillStyle = particle.color;
        ctx.fill();
        ctx.closePath();
      },
    });
  }
  document.title = "Azim's All Projects";
  return (
    <section>
      <ParticlesBg type="random" bg={true} />
      <ParticlesBg num={200} type="custom" config={config} bg={true} />
      <Headroom
        style={{
          webkitTransition: "all .5s ease-in-out",
          mozTransition: "all .5s ease-in-out",
          oTransition: "all .5s ease-in-out",
          transition: "all .5s ease-in-out",
          background: "#0a192f",
          boxShadow: "1px 1px 1px rgba(0,0,0,0.25)",
        }}
      >
        <Container>
          <NavArea />
        </Container>
      </Headroom>
      <Container style={{ background: "#0a192f" }}>
        <Row
          style={{ borderBottom: "8px solid lightCyan" }}
          className="my-5 text-danger text-center"
        >
          <Col lg={6} sm={12} md={{ size: 6, order: 1 }}>
            <h1 className="py-4">There are some of my projects</h1>
          </Col>
          <Col lg={6} sm={12} md={{ size: 6, order: 2 }}>
            <img className="w-100" src={project} alt="" />
          </Col>
        </Row>

        {/* //Projects Area  */}

        <Row className="mt-3 text-center">
          <Col lg={6} sm={12} md={{ size: 6, order: 2 }}>
            <img
              className="img-fluid h-75 w-75"
              src="https://i.ibb.co/1v34gq6/homes-finder-client-min-1-1-1.jpg"
              alt=""
            />
          </Col>
          <Col lg={6} sm={12} md={{ size: 6, order: 1 }}>

            <Card
              style={{ border: "none", fontFamily: "lato", fontSize: "20px" }}
            >
              <CardHeader className="bg-white" tag="h1">
                Homes Finder
              </CardHeader>
              <CardBody>
                <CardTitle style={{ borderBottom: "2px solid red" }}>
                  <h4>Overview</h4>
                </CardTitle>
                <CardText>
                  <ul>
                    <li>
                      Next-JS web Application with Static
                      side generation where people can take
                      service by ordering on this website.
                    </li>
                    <li>
                      • There is an admin dashboard with CRUD
                      operations where admin can see all the
                      operations in the website of client. There
                      is also a client dashboard.
                    </li>
                    <li>
                      • Main stack: Next-JS, MongoDB, ExpressJS, Firebase, SASS, Redux,
                    </li>
                  </ul>{" "}
                </CardText>
                <a
                  style={{ textDecoration: "none" }}
                  href="https://homes-finder-client.vercel.app/"
                  className="text-list"
                >
                  <Button
                    lg
                    block
                    className="my-1"
                    outline={true}
                    color="success"
                  >
                    Live Website
                  </Button>
                </a>
                <a
                  style={{ textDecoration: "none" }}
                  href="https://github.com/Azim-Ahmed/homes-finder-client"
                >
                  <Button lg block className="my-2" color="danger">
                    Repository
                  </Button>
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3 text-center">
          <Col lg={6} sm={12} md={{ size: 6, order: 1 }}>
            <img
              className="img-fluid h-75 w-75"
              src="https://i.ibb.co/Y0gnmQL/creative.png"
              alt=""
            />
          </Col>
          <Col lg={6} sm={12} md={{ size: 6, order: 2 }}>

            <Card
              style={{ border: "none", fontFamily: "lato", fontSize: "20px" }}
            >
              <CardHeader className="bg-white" tag="h1">
                Creative Agency
              </CardHeader>
              <CardBody>
                <CardTitle style={{ borderBottom: "2px solid red" }}>
                  <h4>Overview</h4>
                </CardTitle>
                <CardText>
                  {" "}
                  <ul>
                    <li>
                      A website for those who want to handle their project
                      smoothly.
                    </li>
                    <li>
                      By selecting a specific service ,it’s redirect to login
                      form and it shows a booking form for booking a service .
                      If particular person wants to cancel booking he/she can
                      cancel service.
                    </li>
                    <li>
                      {" "}
                      It has a specific admin panel only admin can access it.
                    </li>
                    <li>
                      I used these material to build this website:HTML,
                      CSS,REACTSTRAP,JAVASCRIPT, REACT,FIREBASE,HEROKU,NODEJS,
                      EXPRESS.JS, MONGODB.
                    </li>
                  </ul>{" "}
                </CardText>
                <a
                  style={{ textDecoration: "none" }}
                  href="https://creative-agency-port.web.app"
                  className="text-list"
                >
                  <Button
                    lg
                    block
                    className="my-1"
                    outline={true}
                    color="success"
                  >
                    Live Website
                  </Button>
                </a>
                <a
                  style={{ textDecoration: "none" }}
                  href="https://github.com/Azim-Ahmed/creative-agency-portal/"
                >
                  <Button lg block className="my-2" color="danger">
                    Repository
                  </Button>
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* //Volunteer Network  */}
        <Row className="my-3 text-center">
          <Col
            data-aos="fade-up"
            data-aos-anchor-placement="center-center"
            lg={6}
            sm={12}
            md={{ size: 6, order: 1 }}
          >
            {/* <ParticlesBg  num={200} type="custom" config={config} bg={true} /> */}

            <Card
              style={{
                border: "none",
                borderRadius: "8px",
                fontFamily: "lato",
                fontSize: "24px",
              }}
            >
              <CardHeader className="bg-white" tag="h1">
                Volunteer Network
              </CardHeader>
              <CardBody>
                <CardTitle style={{ borderBottom: "2px solid red" }}>
                  <h4>Overview</h4>
                </CardTitle>
                <CardText>
                  {" "}
                  <ul>
                    <li>
                      A website for those enthusiast people who want to join in
                      volunteer service.
                    </li>
                    <li>
                      {" "}
                      By selecting a specific Volunteer task, it’s redirect to
                      login form and it shows a booking form for booking a
                      service . If particular person wants to cancel booking
                      he/she can cancel task.
                    </li>
                    <li>
                      {" "}
                      It has an admin part who can add a new volunteer task.
                    </li>
                    <li>
                      I used these material to build this website:HTML,
                      CSS,REACTSTRAP,JAVASCRIPT, REACT,FIREBASE,HEROKU,NODEJS,
                      EXPRESS.JS, MONGODB.
                    </li>
                  </ul>{" "}
                </CardText>
                <a
                  href="https://volunteer-network-portal.web.app/"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    lg
                    block
                    className="my-1"
                    outline={true}
                    color="success"
                  >
                    Live Website
                  </Button>
                </a>
                <a
                  href="https://github.com/Azim-Ahmed/volunteer-network"
                  style={{ textDecoration: "none" }}
                >
                  <Button lg block className="my-2" color="danger">
                    Repository
                  </Button>
                </a>
              </CardBody>
            </Card>
          </Col>
          <Col
            data-aos="fade-up"
            data-aos-anchor-placement="center-center"
            lg={6}
            sm={12}
            md={{ size: 6, order: 2 }}
          >
            <img
              style={{ border: "none", borderRadius: "8px" }}
              className="img-fluid w-100"
              src="https://i.ibb.co/GpfCLfC/voluteer.png"
              alt=""
            />
          </Col>
        </Row>

        {/* Travel guru  */}

        <Row className="my-3 text-center">
          <Col lg={6} sm={12} md={{ size: 6, order: 1 }}>
            <Card
              data-aos="fade-left"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1200"
              style={{
                border: "none",
                borderRadius: "8px",
                fontFamily: "lato",
                fontSize: "24px",
              }}
            >
              <CardHeader className="bg-white" tag="h1">
                Travel Guru
              </CardHeader>
              <CardBody>
                <CardTitle style={{ borderBottom: "2px solid red" }}>
                  <h4>Overview</h4>
                </CardTitle>
                <CardText>
                  {" "}
                  <ul>
                    <li>A travel website for travel enthusiast people.</li>
                    <li>
                      {" "}
                      By selecting a specific travel place , it shows a booking
                      form date Picker for booking . After booking it’s redirect
                      to login form and Choose a hotel room with a specific
                      location.
                    </li>
                    <li>
                      I used these material to build this website:HTML,
                      CSS,REACTSTRAP,JAVASCRIPT, REACT,FIREBASE
                    </li>
                  </ul>{" "}
                </CardText>
                <a
                  href="https://travel-guru-dhaka.web.app/"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    lg
                    block
                    className="my-1"
                    outline={true}
                    color="success"
                  >
                    Live Website
                  </Button>
                </a>
                <a
                  href="https://github.com/Azim-Ahmed/travel-guru-app"
                  style={{ textDecoration: "none" }}
                >
                  <Button lg block className="my-2" color="danger">
                    Repository
                  </Button>
                </a>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6} sm={12} md={{ size: 6, order: 2 }}>
            <img
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1200"
              style={{ border: "none", borderRadius: "8px" }}
              className="img-fluid w-100"
              src="https://i.ibb.co/pbJZswL/Home-min.png"
              alt=""
            />
          </Col>
        </Row>
        <Row className="my-3 text-center">
          <Col lg={6} sm={{ size: 12, order: 2 }} md={{ size: 6, order: 2 }}>
            {/* <ParticlesBg  num={200} type="custom" config={config} bg={true} /> */}

            <Card
              style={{
                border: "none",
                borderRadius: "8px",
                fontFamily: "lato",
                fontSize: "24px",
              }}
            >
              <CardHeader className="bg-white" tag="h1">
                Ema-John
              </CardHeader>
              <CardBody>
                <CardTitle style={{ borderBottom: "2px solid red" }}>
                  <h4>Overview</h4>
                </CardTitle>
                <CardText>
                  {" "}
                  <ul>
                    <li>A web application for e-commerce</li>
                    <li>
                      {" "}
                      By selecting a specific item, it’s redirected to review
                      and it shows a cart button to procceed order.It is a CRUD
                      project
                    </li>
                    <li>
                      I used these material to build this website:HTML,
                      CSS,REACTSTRAP,JAVASCRIPT, REACT,FIREBASE,HEROKU,NODEJS,
                      EXPRESS.JS, MONGODB.
                    </li>
                  </ul>{" "}
                </CardText>
                <a
                  href="https://ema-john-react-firebase.web.app/"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    lg
                    block
                    className="my-1"
                    outline={true}
                    color="success"
                  >
                    Live Website
                  </Button>
                </a>
                <a
                  href="https://github.com/Azim-Ahmed/ema-john-simple/"
                  style={{ textDecoration: "none" }}
                >
                  <Button lg block className="my-2" color="danger">
                    Repository
                  </Button>
                </a>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6} sm={{ size: 12, order: 1 }} md={{ size: 6, order: 1 }}>
            <img
              style={{ border: "none", borderRadius: "8px" }}
              className="img-fluid w-100"
              src="https://i.ibb.co/jh0kHvr/ema-john-screen.png"
              alt=""
            />
          </Col>
        </Row>
      </Container>
      <Footer></Footer>
      <ParticlesBg num={200} type="custom" config={config} bg={true} />
    </section>
  );
};

export default AllProjects;
